export const ADAPTIVE_PLACEMENT_TEST = {
    VOCABULARY_PI: { key: 'VOCABULARY_PI', name: 'Vocabulary (PI)', note: 'Pre-intermediate/ Intermediate (PI)' },

    GRAMMAR_PI: { key: 'GRAMMAR_BE', name: 'Grammar (BE)', note: 'Beginner/Elementary (BE)' },
    GRAMMAR_BE: { key: 'GRAMMAR_PI', name: 'Grammar (PI)', note: 'Pre-intermediate/ Intermediate (PI)' },
    GRAMMAR_UA: { key: 'GRAMMAR_UA', name: 'Grammar (UA)', note: 'Upper-intermediate/ Advanced (UA)' },

    LISTENING_BE: { key: 'LISTENING_BE', name: 'Listening (BE)', note: 'Beginner/Elementary (BE)' },
    LISTENING_PI: { key: 'LISTENING_PI', name: 'Listening (PI)', note: 'Pre-intermediate/ Intermediate (PI)' },
    LISTENING_UA: { key: 'LISTENING_UA', name: 'Listening (UA)', note: 'Upper-intermediate/ Advanced (UA)' },

    READING_B: { key: 'READING_B', name: 'Reading (B)', note: 'Level Pre-intermediate/ Intermediate' },
    READING_E: { key: 'READING_E', name: 'Reading (E)', note: 'Level Pre-intermediate/ Intermediate' },
    READING_P: { key: 'READING_P', name: 'Reading (P)', note: 'Level Pre-intermediate/ Intermediate' },
    READING_I: { key: 'READING_I', name: 'Reading (I)', note: 'Level Pre-intermediate/ Intermediate' },
    READING_U: { key: 'READING_U', name: 'Reading (U)', note: 'Level Pre-intermediate/ Intermediate' },
    READING_A: { key: 'READING_A', name: 'Reading (A)', note: 'Level Pre-intermediate/ Intermediate' },

}

export const GENERAL_PLACEMENT_TEST = {
    math: { key: 'math', name: 'Math' },
    physic: { key: 'physic', name: 'Physic' },
    chemistry: { key: 'chemistry', name: 'Chemistry' },
    biology: { key: 'biology', name: 'Biology' },
    earth: { key: 'earth', name: 'Earth' },
}

export const ACHIEVEMENT_TEST = [
    { key: 'vocabulary', name: 'Vocabulary' },
    { key: 'grammar', name: 'Grammar' },
    { key: 'reading', name: 'Reading' },
    { key: 'listening', name: 'Listening' },
]